export enum EnumTipoCosteCisternas {
        TransporteMaritimo = 1,
        TransporteTerrestre = 2,
        GastosAduana = 3,
        EntregaPuerto = 4,
        RecogidaPuerto = 5,	
        Grua = 6,
        AparcamientoOperativo = 7,
        Paralizaciones = 8,	
        Viaje = 9,	
        Peaje = 10,
        SucesivasDescargas = 11
}
